import { hasProperty } from '@/helpers/has-property';
import type { NavigationState } from '@/routes/helpers/is-from-state';

export const EXPLORE_EXTERNAL_PREFILL_STATE = 'explore_external_prefill_state';

export interface ExploreExternalPrefillState extends NavigationState {
  description: string;
  from: typeof EXPLORE_EXTERNAL_PREFILL_STATE;
}

export const buildExploreExternalPrefillNavigateState = ({
  description,
}: {
  description: string;
}): ExploreExternalPrefillState => ({
  description,
  from: EXPLORE_EXTERNAL_PREFILL_STATE,
});

export const isExploreExternalPrefillState = (
  state: unknown,
): state is ExploreExternalPrefillState => {
  if (!hasProperty('from', state) || !hasProperty('description', state)) {
    return false;
  }

  return (
    state.from === EXPLORE_EXTERNAL_PREFILL_STATE &&
    typeof state.description === 'string'
  );
};
